<div id="background-overlay" class="background-image-overlay" [ngClass]="{'fade-out': fadeOut}">
</div>
<div class="background-image">
</div>
